<div class="fields-container">
  <sk-select
    skSelectSortItems
    [items]="sharingTypes"
    [label]="label"
    [formControl]="valueControl"
    bindLabel="label"
    bindValue="value"
    >
  </sk-select>

  <div [hidden]="!valueControl.value" class="share-select-info-text">
    {{selectedSharingTypeInfo}}
  </div>

  @if (isSpecificSelected) {
    <ng-content></ng-content>
  }
</div>
